export default "__VITE_ASSET__rUWamhVG__"